import assert from '@/sui/tools/assert'
import { flattenSheetFromJSTree, convert, strIndex } from '@/sui/data/flatten/tools'
import { findSurveillance, etbType, sheetStatus } from '@/sui/data/flatten/common'

function initializeToolsUsageSheet (s, p, keySet) {
  const result = {}
  const notInTreeFields = [
    { key: 'module', r: 'Formation' },
    { key: 'surv_id', r: p.sv },
    { key: 'etb_finess', r: s.etb_finess },
    { key: 'etb_region', r: s.etb_region },
    { key: 'etb_nom', r: s.etb_name },
    { key: 'etb_type', r: etbType(s.etb_type) },
    { key: 'fiche_version', r: p.v },
    { key: 'fiche_état', r: sheetStatus(p.st) }
  ]

  for (let i = 0; i < notInTreeFields.length; i++) {
    const item = notInTreeFields[i]
    const key = `_${strIndex(i)}_${item.key}`
    result[key] = item.r
    keySet.add(key)
  }

  return {
    result: result,
    initCount: notInTreeFields.length
  }
}

const reducer = (tree) => (result, p) => {
  const s = findSurveillance(result, p)
  if (result.keys == null) {
    result.keys = []
  }

  result.r[result.i++] = flattenSheetFromJSTree(
    initializeToolsUsageSheet, tree, p, s, result.all
  )

  return result
}

function flatten2026 () {
  return (params) => {
    const m = params.type
    const sheets = params.sheets
    const tree = params.treeFields

    assert(m === 'toolsUsage')
    assert(sheets.length !== 0)
    assert(tree != null)

    return convert(params, reducer(tree), ['all'])
  }
}

export default {
  '2026': flatten2026()
}
